var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[50556]) {
		innerRemote = __webpack_require__(50556);
	}
	var gs = __webpack_require__.g || globalThis
	gs["host-template"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();